import 'src/core/index'



// WEBPACK FOOTER //
// ./index.js